export default "__VITE_ASSET__B25Zj28e__"